export const getWaterfallFlowId = state => state.waterfallFlows.waterfallFlow.id;
export const getWaterfallFlowData = state => state.waterfallFlows.waterfallFlow;
export const waterfallFlowIsFetching = state => state.waterfallFlows.loading;